export class Parameter {
    settingName : ParameterName;
    settingValue : any;
    enabled : boolean;
}

/**
 * Enum containing the name of all the neccessary parameters
 */
export enum ParameterName {
    /** Refresh interval for all widgets on dashboard to update */
    DASHBOARD_REFRESH_INTERVAL = 'DASHBOARD_REFRESH_INTERVAL'
}


// WEBPACK FOOTER //
// ./src/app/models/parameter.ts